import React from 'react';
import { PictoProps } from './index';

export const GiftCard = (props: PictoProps) => (
  <div nonce="__nonce__" style={{ position: 'relative' }}>
    <style nonce="__nonce__">
      {`.svgText {
        color: #fff;
        position: absolute;
        font-size: 9.7px;
        transform: rotate(-9deg);
        right: 26%;
        bottom: 27%;
        width: 47%;
        line-height: 1em;
        text-align: right;
        text-transform: uppercase;
      };`}
    </style>
    <svg
      width={props.width || '99'}
      height={props.height || '84'}
      viewBox="0 0 99 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="card"
        y="37.9648"
        width="75"
        height="46"
        rx="6"
        transform="rotate(-8 0 37.9648)"
        fill="#009989"
      />
      <mask
        id="mask0_573_24504"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="28"
        width="80"
        height="55"
      >
        <rect
          y="37.9648"
          width="75"
          height="46"
          rx="6"
          transform="rotate(-8 0 37.9648)"
          fill="#0A94A8"
        />
      </mask>
      <g mask="url(#mask0_573_24504)">
        <path
          className="string"
          d="M29.3375 25.7807L21.5471 46.2501C21.4401 45.9523 21.2888 45.6743 21.0809 45.4483C20.8212 45.1657 20.4651 44.8466 19.9396 44.6833C19.5103 44.5566 18.9481 44.4896 18.2363 44.6227C16.7362 44.8966 16.1255 45.7294 15.9133 46.3833C15.2571 48.3006 16.9551 51.0773 18.2007 52.7267C16.2057 53.1429 13.0912 54.0879 12.3066 55.9564C12.0303 56.5859 11.9329 57.614 12.8911 58.8602C13.8615 60.0744 14.8774 60.2039 15.577 60.1029C15.8825 60.0722 16.1804 59.9652 16.4584 59.8139L7.5812 83.1387L9.28164 83.7859L20.227 54.9304C21.234 56.0483 22.5911 57.8871 22.6436 59.4865C22.6651 60.0089 23.0731 60.3846 23.5955 60.3631C24.118 60.3415 24.4936 59.9335 24.4721 59.4111C24.418 57.3335 22.9814 55.3176 21.8948 54.0225C23.5201 53.6126 25.8586 52.7762 27.0801 51.1107C27.3794 50.7104 27.3059 50.1315 26.9056 49.8322C26.8215 49.7635 26.7253 49.7268 26.629 49.6902C26.2639 49.588 25.8576 49.6905 25.627 50.0067C24.6849 51.2276 22.6442 51.9569 21.1839 52.3194L31.0701 26.4401L29.3375 25.7807ZM17.626 46.9984C17.6626 46.9021 17.7847 46.5813 18.5851 46.4084C19.3855 46.2355 19.6132 46.5058 19.6851 46.6066C20.3284 47.329 20.0404 49.5334 19.5369 51.4355C18.3754 49.8548 17.3162 47.9089 17.626 46.9984ZM15.3046 58.3095C15.2603 58.3294 15.1518 58.3249 15.0235 58.276C14.863 58.215 14.6186 58.0852 14.3511 57.7263C13.8361 57.0528 13.9781 56.7762 14.0269 56.6479C14.4009 55.7618 16.4538 55.0004 18.3846 54.5598C17.496 56.3153 16.2455 58.1534 15.3046 58.3095Z"
          fill="white"
        />
      </g>
      {/*<path className="text" d="M41.3856 60.9627C42.767 60.7685 43.4763 60.0599 43.9505 59.1662L42.519 58.4222C42.2086 58.9294 41.868 59.2862 41.2174 59.3777C40.3439 59.5004 39.6263 58.856 39.4948 57.9202L39.4922 57.9024C39.3645 56.9933 39.8755 56.1672 40.7489 56.0444C41.346 55.9605 41.7961 56.1881 42.2152 56.5836L43.3749 55.3936C42.7146 54.7048 41.8195 54.2853 40.545 54.4644C38.6556 54.73 37.4567 56.3526 37.7123 58.1707L37.7148 58.1886C37.9766 60.0513 39.6031 61.2132 41.3856 60.9627ZM44.5017 60.3975L46.3199 60.142L46.6089 58.9653L49.0153 58.6271L49.6264 59.6773L51.4802 59.4168L47.9412 53.5068L46.2746 53.741L44.5017 60.3975ZM46.9278 57.5481L47.3826 55.6756L48.327 57.3515L46.9278 57.5481ZM52.2637 59.3066L53.9928 59.0636L53.7272 57.1742L54.4669 57.0702L54.4848 57.0677L56.007 58.7806L58.0033 58.5L56.2093 56.5345C56.9384 56.0958 57.3575 55.3916 57.2234 54.438L57.2209 54.4202C57.1345 53.8052 56.8797 53.3502 56.4642 53.0451C55.9852 52.6762 55.2906 52.5193 54.337 52.6533L51.387 53.0679L52.2637 59.3066ZM53.5368 55.8195L53.3264 54.3222L54.4583 54.1632C55.0376 54.0817 55.4291 54.2812 55.498 54.7714L55.5005 54.7892C55.5644 55.2437 55.2658 55.5765 54.6776 55.6592L53.5368 55.8195ZM60.3718 58.1671L62.1008 57.9241L61.437 53.2005L63.3086 52.9375L63.0956 51.4224L57.6234 52.1915L57.8364 53.7066L59.708 53.4435L60.3718 58.1671ZM64.9096 57.5294L69.9719 56.8179L69.7652 55.3474L66.4141 55.8183L66.2751 54.829L69.2697 54.4082L69.078 53.0446L66.0835 53.4654L65.9507 52.5207L69.2572 52.056L69.0505 50.5855L64.0328 51.2907L64.9096 57.5294ZM34.4787 72.0317C35.8601 71.8375 36.5694 71.1289 37.0436 70.2352L35.6121 69.4912C35.3017 69.9983 34.961 70.3552 34.3104 70.4467C33.437 70.5694 32.7194 69.925 32.5878 68.9892L32.5853 68.9714C32.4576 68.0623 32.9686 67.2362 33.842 67.1134C34.4391 67.0295 34.8892 67.2571 35.3083 67.6526L36.468 66.4626C35.8077 65.7738 34.9126 65.3543 33.6381 65.5334C31.7487 65.799 30.5498 67.4216 30.8054 69.2397L30.8079 69.2575C31.0696 71.1202 32.6962 72.2822 34.4787 72.0317ZM37.5948 71.4665L39.413 71.211L39.702 70.0343L42.1084 69.6961L42.7195 70.7463L44.5732 70.4857L41.0343 64.5757L39.3677 64.81L37.5948 71.4665ZM40.0209 68.6171L40.4757 66.7446L41.4201 68.4205L40.0209 68.6171ZM45.3568 70.3756L47.7275 70.0424C49.9735 69.7268 51.0957 68.2058 50.8427 66.4055L50.8402 66.3877C50.5872 64.5874 49.1145 63.4856 46.8864 63.7987L44.48 64.1369L45.3568 70.3756ZM46.8704 68.5997L46.4245 65.4269L47.1286 65.3279C48.1624 65.1826 48.9301 65.6655 49.0704 66.6637L49.0729 66.6815C49.2144 67.6886 48.6083 68.3554 47.5745 68.5007L46.8704 68.5997ZM52.3499 69.3928L57.4122 68.6813L57.2055 67.2108L53.8545 67.6817L53.7154 66.6925L56.71 66.2716L56.5184 64.908L53.5238 65.3289L53.391 64.3842L56.6975 63.9195L56.4908 62.4489L51.4732 63.1541L52.3499 69.3928ZM57.9736 68.6024L59.7917 68.3469L60.0808 67.1702L62.4871 66.832L63.0982 67.8822L64.952 67.6217L61.4131 61.7117L59.7465 61.9459L57.9736 68.6024ZM60.3997 65.7531L60.8545 63.8805L61.7989 65.5564L60.3997 65.7531ZM68.3156 67.2671C70.0892 67.0178 71.1149 65.9739 70.8318 63.9597L70.3458 60.5017L68.5901 60.7485L69.0836 64.26C69.2063 65.1334 68.8094 65.6072 68.1142 65.7049C67.4191 65.8026 66.9044 65.4387 66.7779 64.5386L66.2907 61.0716L64.5349 61.3184L65.0272 64.821C65.3015 66.7728 66.5421 67.5164 68.3156 67.2671Z" fill="white"/>*/}
      <path
        d="M62.0805 36.3088C60.7025 36.5025 59.4567 37.2367 58.6189 38.3484C57.7812 39.4602 57.4188 40.8601 57.6125 42.2381C57.8061 43.616 58.5403 44.8619 59.6521 45.6996C60.7638 46.5374 62.1637 46.8997 63.5417 46.7061C64.9197 46.5124 66.1655 45.7782 67.0033 44.6665C67.841 43.5547 68.2034 42.1548 68.0097 40.7768C67.8813 39.863 67.5145 39.0004 66.9482 38.2754C66.3818 37.5503 65.6307 36.9843 64.7776 36.6397C63.9245 36.2952 62.9914 36.1808 62.0805 36.3088ZM62.5596 43.8858L60.2034 42.1076L60.9937 41.0588L62.304 42.0461L64.2791 39.4285L65.328 40.2189L62.5596 43.8858Z"
        fill="#EAE000"
      />
      <path
        d="M95.2976 22.3291L84.3994 26.5189"
        stroke="#FCE84E"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M87.0142 10.4824L79.6966 19.708"
        stroke="#FCE84E"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M74.1131 4.83743L72.4461 16.6642"
        stroke="#FCE84E"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M56.0412 8.52579L62.301 18.6851"
        stroke="#FCE84E"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
    <div className="svgText">{props.text || 'carte cadeau'}</div>
  </div>
);
